import { render, staticRenderFns } from "./ItemCardFrameAssemblyFrame.vue?vue&type=template&id=5662d3ea&scoped=true"
import script from "./ItemCardFrameAssemblyFrame.vue?vue&type=script&lang=ts"
export * from "./ItemCardFrameAssemblyFrame.vue?vue&type=script&lang=ts"
import style0 from "./ItemCardFrameAssemblyFrame.vue?vue&type=style&index=0&id=5662d3ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5662d3ea",
  null
  
)

export default component.exports